import { ONE_LINK_URL } from "../shared/constants";
import Device from "../shared/types/device";

export const redirectToApp = (device: Device) => {
  window.location.assign(
    device === 'mobile' ? ONE_LINK_URL : 'https://web.uala.com.ar',
  );
}